import React from "react";

interface GlobalMetaScriptsProps {
  structuredData?: object;
  serviceSchema?: object;
  businessSchema?: object;
  productSchema?: object;
  webPageSchema?: object;
  breadcrumbSchema?: object;
  faqSchema?: object;
}

const GlobalMetaScripts: React.FC<GlobalMetaScriptsProps> = ({
  structuredData,
  serviceSchema,
  businessSchema,
  productSchema,
  webPageSchema,
  breadcrumbSchema,
  faqSchema,
}) => {
  const schemas = [
    structuredData,
    serviceSchema,
    businessSchema,
    productSchema,
    webPageSchema,
    breadcrumbSchema,
    faqSchema,
  ]
    .filter(Boolean)
    .map((schema, index) => (
      <script
        key={index}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    ));

  return <>{schemas}</>;
};

export default GlobalMetaScripts;
